export enum RATING_MODAL_TEST_IDS {
    TITLE = 'rating_modal_title',
    DESCRIPTION = 'rating_modal_description',
    START_CONTAINER = 'rating_modal_start_container',
    STAR_BUTTON = 'rating_modal_start_button',
    RATE_BUTTON = 'rating_modal_rate_button',
    REMOVE_RATING_BUTTON = 'rating_modal_remove_rate_button',
}
